import script from "./Introduction.vue?vue&type=script&setup=true&lang=js"
export * from "./Introduction.vue?vue&type=script&setup=true&lang=js"

import "./Introduction.vue?vue&type=style&index=0&id=b0ab4310&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0ab4310"]])

export default __exports__